import videojs from 'video.js';
const Button = videojs.getComponent('Button');
// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
const onPlayerReady = (player) => {
    player.addClass('vjs-theatre-layout-button');
    // @ts-expect-error - This is a legit problem, but it predates strict TS
    player.controlBar.settings = player.controlBar.addChild('theatreLayoutButton', {}, 12);
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function theatreLayoutButton
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
const theatreLayoutButton = function () {
    // document.sbInit++;
    this.ready(() => {
        onPlayerReady(this);
    });
};
/**
 * Button to seek forward/back
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class SeekToggle
 */
class TheatreLayoutButton extends Button {
    constructor(player, options) {
        super(player, options);
    }
    buildCSSClass() {
        return `vjs-theatre-layout-button ${super.buildCSSClass()}`;
    }
    handleClick() {
        //
    }
}
videojs.registerComponent('TheatreLayoutButton', TheatreLayoutButton);
// Register the plugin with video.js.
registerPlugin('theatreLayoutButton', theatreLayoutButton);
export default theatreLayoutButton;
//# sourceMappingURL=TheatreLayoutButton.js.map